//     This code was generated by a Reinforced.Typings tool.
//     Changes to this file may cause incorrect behavior and will be lost if
//     the code is regenerated.

import { CancelToken, AxiosRequestConfig, AxiosInstance } from 'axios';
import { BusinessObjectType } from '../../../Core/BusinessObjectType';
import DefaultDtoControllerProxy from './DefaultDtoControllerProxy';
import { IQuoteDTO } from '../../../DTO/IQuoteDTO';
import { IActivityDTO } from '../../../DTO/IActivityDTO';
import { IERPRowGroupingDTO } from '../../../DTO/IERPRowGroupingDTO';
import { IAddProductsByCodeRequest } from '../IAddProductsByCodeRequest';
import { ICloneRowsGroupsRequest } from '../ICloneRowsGroupsRequest';
import { IImportRowsRequest } from '../IImportRowsRequest';
import { IERPRowDTO } from '../../../DTO/IERPRowDTO';
import { IFilePreview } from './IFilePreview';

//element.Name=QuoteController result.Name=QuoteController element.FullName=Digita.Tustena.UIApiControllers.BusinessObject.DTO.QuoteController);
/** WebApiController: QuoteController */
export class QuoteController extends DefaultDtoControllerProxy<IQuoteDTO>
{
	constructor (axios: AxiosInstance)
	{
		super(axios, 'Quotes', BusinessObjectType.Quote);
	}
	public ConvertToOrder(dto: IQuoteDTO, cancelToken?: CancelToken, axiosConfig?: AxiosRequestConfig) : Promise<number>
	{
		return (this.axios.post('Quotes/ConvertToOrder', dto, { ...axiosConfig, cancelToken })).then(r => r.data);
	}
	public StoreDocument(req: any, cancelToken?: CancelToken, axiosConfig?: AxiosRequestConfig) : Promise<number>
	{
		return (this.axios.post('Quotes/StoreDocument', req, { ...axiosConfig, cancelToken })).then(r => r.data);
	}
	public CreateRevision(dto: IQuoteDTO, useNewNumber: boolean, cancelToken?: CancelToken, axiosConfig?: AxiosRequestConfig) : Promise<any>
	{
		return (this.axios.post('Quotes/CreateRevision?&useNewNumber='+useNewNumber, dto, { ...axiosConfig, cancelToken })).then(r => r.data);
	}
	public CreateCopy(dto: IQuoteDTO, cancelToken?: CancelToken, axiosConfig?: AxiosRequestConfig) : Promise<any>
	{
		return (this.axios.post('Quotes/CreateCopy', dto, { ...axiosConfig, cancelToken })).then(r => r.data);
	}
	public SaveFromOpportunity(quoteDto: IQuoteDTO, cancelToken?: CancelToken, axiosConfig?: AxiosRequestConfig) : Promise<any>
	{
		return (this.axios.post('Quotes/SaveFromOpportunity', quoteDto, { ...axiosConfig, cancelToken })).then(r => r.data);
	}
	public Copy(id: number, cancelToken?: CancelToken, axiosConfig?: AxiosRequestConfig) : Promise<number>
	{
		return (this.axios.post('Quotes/Copy?&id='+id, null, { ...axiosConfig, cancelToken })).then(r => r.data);
	}
	public Review(id: number, useNewNumber: boolean = false, cancelToken?: CancelToken, axiosConfig?: AxiosRequestConfig) : Promise<number>
	{
		return (this.axios.post('Quotes/Review?&id='+id+'&useNewNumber='+useNewNumber, null, { ...axiosConfig, cancelToken })).then(r => r.data);
	}
	public CheckVatValue(req: any, cancelToken?: CancelToken, axiosConfig?: AxiosRequestConfig) : Promise<any>
	{
		return (this.axios.post('Quotes/CheckVatValue', req, { ...axiosConfig, cancelToken })).then(r => r.data);
	}
	public SaveWithDocument(req: any, cancelToken?: CancelToken, axiosConfig?: AxiosRequestConfig) : Promise<any>
	{
		return (this.axios.post('Quotes/SaveWithDocument', req, { ...axiosConfig, cancelToken })).then(r => r.data);
	}
	public RequestedByChanged(crossId: number, crossType: BusinessObjectType, erpType: BusinessObjectType, cancelToken?: CancelToken, axiosConfig?: AxiosRequestConfig) : Promise<any>
	{
		return (this.axios.post('Quotes/RequestedByChanged?&crossId='+crossId+'&crossType='+crossType+'&erpType='+erpType, null, { ...axiosConfig, cancelToken })).then(r => r.data);
	}
	public OnAnagraphicChanged(dto: IQuoteDTO, cancelToken?: CancelToken, axiosConfig?: AxiosRequestConfig) : Promise<any[]>
	{
		return (this.axios.post('Quotes/OnAnagraphicChanged', dto, { ...axiosConfig, cancelToken })).then(r => r.data);
	}
	public GetPriceListCurrency(listId: number, cancelToken?: CancelToken, axiosConfig?: AxiosRequestConfig) : Promise<number>
	{
		return (this.axios.get('Quotes/GetPriceListCurrency?&listId='+listId, { ...axiosConfig, cancelToken })).then(r => r.data);
	}
	public SendEmailWithPrintTemplate(dto: IActivityDTO, parentId: number, parentType: BusinessObjectType, templateName?: string, cancelToken?: CancelToken, axiosConfig?: AxiosRequestConfig) : Promise<number>
	{
		return (this.axios.post('Quotes/SendEmailWithPrintTemplate?&parentId='+parentId+'&parentType='+parentType+((templateName === null || templateName === undefined) ? '' : ('&templateName='+encodeURIComponent(templateName))), dto, { ...axiosConfig, cancelToken })).then(r => r.data);
	}
	public OnGetNewEmptyGroupRow(dto: IQuoteDTO, isFooterGroup: boolean, cancelToken?: CancelToken, axiosConfig?: AxiosRequestConfig) : Promise<any>
	{
		return (this.axios.post('Quotes/OnGetNewEmptyGroupRow?&isFooterGroup='+isFooterGroup, dto, { ...axiosConfig, cancelToken })).then(r => r.data);
	}
	public OnGroupByRowType(dto: IQuoteDTO, cancelToken?: CancelToken, axiosConfig?: AxiosRequestConfig) : Promise<IQuoteDTO>
	{
		return (this.axios.post('Quotes/OnGroupByRowType', dto, { ...axiosConfig, cancelToken })).then(r => r.data);
	}
	public OnGroupByProductCategory(dto: IQuoteDTO, cancelToken?: CancelToken, axiosConfig?: AxiosRequestConfig) : Promise<IQuoteDTO>
	{
		return (this.axios.post('Quotes/OnGroupByProductCategory', dto, { ...axiosConfig, cancelToken })).then(r => r.data);
	}
	public OnDiscountFormulaGroupingChanged(dto: IERPRowGroupingDTO, cancelToken?: CancelToken, axiosConfig?: AxiosRequestConfig) : Promise<any>
	{
		return (this.axios.post('Quotes/OnDiscountFormulaGroupingChanged', dto, { ...axiosConfig, cancelToken })).then(r => r.data);
	}
	public OnGroupTaxableAmountWithDiscountChanged(dto: IERPRowGroupingDTO, taxableAmountWithDiscount: number, extensionPartIdx?: number, decimals: number = 2, cancelToken?: CancelToken, axiosConfig?: AxiosRequestConfig) : Promise<any>
	{
		return (this.axios.post('Quotes/OnGroupTaxableAmountWithDiscountChanged?&taxableAmountWithDiscount='+taxableAmountWithDiscount+((extensionPartIdx === null || extensionPartIdx === undefined) ? '' : ('&extensionPartIdx='+extensionPartIdx))+'&decimals='+decimals, dto, { ...axiosConfig, cancelToken })).then(r => r.data);
	}
	public GetInfo(dto: IQuoteDTO, cancelToken?: CancelToken, axiosConfig?: AxiosRequestConfig) : Promise<any>
	{
		return (this.axios.post('Quotes/GetInfo', dto, { ...axiosConfig, cancelToken })).then(r => r.data);
	}
	public AddProductsByCode(r: IAddProductsByCodeRequest, insertPosition: number, overrideCurrent: boolean, lang: string, cancelToken?: CancelToken, axiosConfig?: AxiosRequestConfig) : Promise<IQuoteDTO>
	{
		return (this.axios.post('Quotes/AddProductsByCode?&insertPosition='+insertPosition+'&overrideCurrent='+overrideCurrent+((lang === null || lang === undefined) ? '' : ('&lang='+encodeURIComponent(lang))), r, { ...axiosConfig, cancelToken })).then(r => r.data);
	}
	public CloneRowsGroups(r: ICloneRowsGroupsRequest, cancelToken?: CancelToken, axiosConfig?: AxiosRequestConfig) : Promise<IQuoteDTO>
	{
		return (this.axios.post('Quotes/CloneRowsGroups', r, { ...axiosConfig, cancelToken })).then(r => r.data);
	}
	public ImportRows(r: IImportRowsRequest, cancelToken?: CancelToken, axiosConfig?: AxiosRequestConfig) : Promise<IQuoteDTO>
	{
		return (this.axios.post('Quotes/ImportRows', r, { ...axiosConfig, cancelToken })).then(r => r.data);
	}
	public GetNewRowInstance(cancelToken?: CancelToken, axiosConfig?: AxiosRequestConfig) : Promise<IERPRowDTO>
	{
		return (this.axios.get('Quotes/GetNewRowInstance', { ...axiosConfig, cancelToken })).then(r => r.data);
	}
	public ApplyCalculateTotalDocument(dto: IQuoteDTO, cancelToken?: CancelToken, axiosConfig?: AxiosRequestConfig) : Promise<IQuoteDTO>
	{
		return (this.axios.post('Quotes/ApplyCalculateTotalDocument', dto, { ...axiosConfig, cancelToken })).then(r => r.data);
	}
	public ApplyCalculateTotalDocumentWithFooterTotals(dto: IQuoteDTO, cancelToken?: CancelToken, axiosConfig?: AxiosRequestConfig) : Promise<any>
	{
		return (this.axios.post('Quotes/ApplyCalculateTotalDocumentWithFooterTotals', dto, { ...axiosConfig, cancelToken })).then(r => r.data);
	}
	public NewEmptyRow(dto: IQuoteDTO, cancelToken?: CancelToken, axiosConfig?: AxiosRequestConfig) : Promise<IERPRowDTO>
	{
		return (this.axios.post('Quotes/NewEmptyRow', dto, { ...axiosConfig, cancelToken })).then(r => r.data);
	}
	public CatalogCodeChanged(dto: IQuoteDTO, rowIndex: number, cancelToken?: CancelToken, axiosConfig?: AxiosRequestConfig) : Promise<IERPRowDTO>
	{
		return (this.axios.post('Quotes/CatalogCodeChanged?&rowIndex='+rowIndex, dto, { ...axiosConfig, cancelToken })).then(r => r.data);
	}
	public LinkedProducts(dto: IQuoteDTO, rowIndex: number, cancelToken?: CancelToken, axiosConfig?: AxiosRequestConfig) : Promise<any>
	{
		return (this.axios.post('Quotes/LinkedProducts?&rowIndex='+rowIndex, dto, { ...axiosConfig, cancelToken })).then(r => r.data);
	}
	public PriceListChanged(dto: IQuoteDTO, rowIndex: number, cancelToken?: CancelToken, axiosConfig?: AxiosRequestConfig) : Promise<IERPRowDTO>
	{
		return (this.axios.post('Quotes/PriceListChanged?&rowIndex='+rowIndex, dto, { ...axiosConfig, cancelToken })).then(r => r.data);
	}
	public UnitPriceChanged(dto: IQuoteDTO, rowIndex: number, cancelToken?: CancelToken, axiosConfig?: AxiosRequestConfig) : Promise<IERPRowDTO>
	{
		return (this.axios.post('Quotes/UnitPriceChanged?&rowIndex='+rowIndex, dto, { ...axiosConfig, cancelToken })).then(r => r.data);
	}
	public QtaChanged(dto: IQuoteDTO, rowIndex: number, cancelToken?: CancelToken, axiosConfig?: AxiosRequestConfig) : Promise<IERPRowDTO>
	{
		return (this.axios.post('Quotes/QtaChanged?&rowIndex='+rowIndex, dto, { ...axiosConfig, cancelToken })).then(r => r.data);
	}
	public UnitMeasureChanged(dto: IQuoteDTO, rowIndex: number, cancelToken?: CancelToken, axiosConfig?: AxiosRequestConfig) : Promise<IERPRowDTO>
	{
		return (this.axios.post('Quotes/UnitMeasureChanged?&rowIndex='+rowIndex, dto, { ...axiosConfig, cancelToken })).then(r => r.data);
	}
	public TaxCodeChanged(dto: IQuoteDTO, rowIndex: number, cancelToken?: CancelToken, axiosConfig?: AxiosRequestConfig) : Promise<IERPRowDTO>
	{
		return (this.axios.post('Quotes/TaxCodeChanged?&rowIndex='+rowIndex, dto, { ...axiosConfig, cancelToken })).then(r => r.data);
	}
	public DiscountFormulaChanged(dto: IQuoteDTO, rowIndex: number, cancelToken?: CancelToken, axiosConfig?: AxiosRequestConfig) : Promise<IERPRowDTO>
	{
		return (this.axios.post('Quotes/DiscountFormulaChanged?&rowIndex='+rowIndex, dto, { ...axiosConfig, cancelToken })).then(r => r.data);
	}
	public CostChanged(dto: IQuoteDTO, rowIndex: number, cancelToken?: CancelToken, axiosConfig?: AxiosRequestConfig) : Promise<IERPRowDTO>
	{
		return (this.axios.post('Quotes/CostChanged?&rowIndex='+rowIndex, dto, { ...axiosConfig, cancelToken })).then(r => r.data);
	}
	public GainChanged(dto: IQuoteDTO, rowIndex: number, cancelToken?: CancelToken, axiosConfig?: AxiosRequestConfig) : Promise<IERPRowDTO>
	{
		return (this.axios.post('Quotes/GainChanged?&rowIndex='+rowIndex, dto, { ...axiosConfig, cancelToken })).then(r => r.data);
	}
	public PercentageGainChanged(dto: IQuoteDTO, rowIndex: number, cancelToken?: CancelToken, axiosConfig?: AxiosRequestConfig) : Promise<IERPRowDTO>
	{
		return (this.axios.post('Quotes/PercentageGainChanged?&rowIndex='+rowIndex, dto, { ...axiosConfig, cancelToken })).then(r => r.data);
	}
	public ProcessOnChangeListId(dto: IQuoteDTO, cancelToken?: CancelToken, axiosConfig?: AxiosRequestConfig) : Promise<IQuoteDTO>
	{
		return (this.axios.post('Quotes/ProcessOnChangeListId', dto, { ...axiosConfig, cancelToken })).then(r => r.data);
	}
	public ProcessOnChangeCurrency(dto: IQuoteDTO, cancelToken?: CancelToken, axiosConfig?: AxiosRequestConfig) : Promise<IQuoteDTO>
	{
		return (this.axios.post('Quotes/ProcessOnChangeCurrency', dto, { ...axiosConfig, cancelToken })).then(r => r.data);
	}
	public ExportRowsInExcel(dto: IQuoteDTO, exportDescription: boolean, exportDescriptionNewLine: boolean, exportExtensions: boolean, exportFreeFields: boolean, cancelToken?: CancelToken, axiosConfig?: AxiosRequestConfig) : Promise<any>
	{
		return (this.axios.post('Quotes/ExportRowsInExcel?&exportDescription='+exportDescription+'&exportDescriptionNewLine='+exportDescriptionNewLine+'&exportExtensions='+exportExtensions+'&exportFreeFields='+exportFreeFields, dto, { ...axiosConfig, cancelToken })).then(r => r.data);
	}
	public RebuildGrouping(dto: IQuoteDTO, cancelToken?: CancelToken, axiosConfig?: AxiosRequestConfig) : Promise<IQuoteDTO>
	{
		return (this.axios.post('Quotes/RebuildGrouping', dto, { ...axiosConfig, cancelToken })).then(r => r.data);
	}
	public RecalcDocumentTotal(dto: IQuoteDTO, cancelToken?: CancelToken, axiosConfig?: AxiosRequestConfig) : Promise<any>
	{
		return (this.axios.post('Quotes/RecalcDocumentTotal', dto, { ...axiosConfig, cancelToken })).then(r => r.data);
	}
	public Templates(cancelToken?: CancelToken, axiosConfig?: AxiosRequestConfig) : Promise<any[]>
	{
		return (this.axios.get('Quotes/Templates', { ...axiosConfig, cancelToken })).then(r => r.data);
	}
	public Download(id: number, filename: string, template?: string, request?: any, inline: boolean = false, cancelToken?: CancelToken, axiosConfig?: AxiosRequestConfig) : Promise<any>
	{
		return (this.axios.get('Quotes/Download?&id='+id+((filename === null || filename === undefined) ? '' : ('&filename='+encodeURIComponent(filename)))+((template === null || template === undefined) ? '' : ('&template='+encodeURIComponent(template)))+((request === null || request === undefined) ? '' : ('&'+Object.keys(request).filter(k => request[k]).map(k => k+'='+encodeURIComponent(request[k])).join('&')))+'&inline='+inline, { ...axiosConfig, cancelToken })).then(r => r.data);
	}
	public HtmlPreview(id: number, template?: string, request?: any, cancelToken?: CancelToken, axiosConfig?: AxiosRequestConfig) : Promise<string>
	{
		return (this.axios.post('Quotes/HtmlPreview?&id='+id+((template === null || template === undefined) ? '' : ('&template='+encodeURIComponent(template)))+((request === null || request === undefined) ? '' : ('&'+Object.keys(request).filter(k => request[k]).map(k => k+'='+encodeURIComponent(request[k])).join('&'))), null, { ...axiosConfig, cancelToken })).then(r => r.data);
	}
	public Previews(id: number, template?: string, request?: any, cancelToken?: CancelToken, axiosConfig?: AxiosRequestConfig) : Promise<IFilePreview[]>
	{
		return (this.axios.post('Quotes/Previews?&id='+id+((template === null || template === undefined) ? '' : ('&template='+encodeURIComponent(template)))+((request === null || request === undefined) ? '' : ('&'+Object.keys(request).filter(k => request[k]).map(k => k+'='+encodeURIComponent(request[k])).join('&'))), null, { ...axiosConfig, cancelToken })).then(r => r.data);
	}
	public Preview(id: number, page: number = 1, zoom: number = 0, template?: string, request?: any, cancelToken?: CancelToken, axiosConfig?: AxiosRequestConfig) : Promise<any>
	{
		return (this.axios.get('Quotes/Preview?&id='+id+'&page='+page+'&zoom='+zoom+((template === null || template === undefined) ? '' : ('&template='+encodeURIComponent(template)))+((request === null || request === undefined) ? '' : ('&'+Object.keys(request).filter(k => request[k]).map(k => k+'='+encodeURIComponent(request[k])).join('&'))), { ...axiosConfig, cancelToken })).then(r => r.data);
	}
	public PrintHtml(dto: IQuoteDTO, template: string, addHeaderAndFooter: boolean = false, request?: any, cancelToken?: CancelToken, axiosConfig?: AxiosRequestConfig) : Promise<any>
	{
		return (this.axios.post('Quotes/PrintHtml?'+((template === null || template === undefined) ? '' : ('&template='+encodeURIComponent(template)))+'&addHeaderAndFooter='+addHeaderAndFooter+((request === null || request === undefined) ? '' : ('&'+Object.keys(request).filter(k => request[k]).map(k => k+'='+encodeURIComponent(request[k])).join('&'))), dto, { ...axiosConfig, cancelToken })).then(r => r.data);
	}
	public GetDownloadUrl(id: number, template?: string, request?: any, cancelToken?: CancelToken, axiosConfig?: AxiosRequestConfig) : Promise<string>
	{
		return (this.axios.get('Quotes/GetDownloadUrl?&id='+id+((template === null || template === undefined) ? '' : ('&template='+encodeURIComponent(template)))+((request === null || request === undefined) ? '' : ('&'+Object.keys(request).filter(k => request[k]).map(k => k+'='+encodeURIComponent(request[k])).join('&'))), { ...axiosConfig, cancelToken })).then(r => r.data);
	}
	public Archive(id: number, template?: string, request?: any, cancelToken?: CancelToken, axiosConfig?: AxiosRequestConfig) : Promise<number>
	{
		return (this.axios.get('Quotes/Archive?&id='+id+((template === null || template === undefined) ? '' : ('&template='+encodeURIComponent(template)))+((request === null || request === undefined) ? '' : ('&'+Object.keys(request).filter(k => request[k]).map(k => k+'='+encodeURIComponent(request[k])).join('&'))), { ...axiosConfig, cancelToken })).then(r => r.data);
	}
	public PrintParameters(id: number, cancelToken?: CancelToken, axiosConfig?: AxiosRequestConfig) : Promise<any>
	{
		return (this.axios.get('Quotes/PrintParameters?&id='+id, { ...axiosConfig, cancelToken })).then(r => r.data);
	}
	public GetFull(id: number, cancelToken?: CancelToken, axiosConfig?: AxiosRequestConfig) : Promise<IQuoteDTO>
	{
		return (this.axios.get('Quotes/GetFull?&id='+id, { ...axiosConfig, cancelToken })).then(r => r.data);
	}
}
